export default "__VITE_ASSET__72aa8de4__"